import { z } from 'zod';
import {
  schemaCodeRubrique,
  schemaPosition,
  schemaReferencePlan,
  RUBRIQUE_EMPLACEMENT_DEFAUT,
} from './marches-structure';

const coordonnee = z.tuple([z.number().min(-180).max(180), z.number().min(-85).max(85)]);
export const schemaCreationAllee = z
  .strictObject({
    code: schemaReferencePlan.optional(),
    nom: z.string().trim().min(1).max(120),
    ligne: z.strictObject({
      type: z.literal('LineString'),
      coordinates: z.array(coordonnee).min(2).max(1000),
    }),
    source: z.enum(['manuel', 'osm']).default('manuel'),
    reference_source: z.string().trim().min(1).max(300).optional(),
  })
  .refine((v) => v.source !== 'osm' || Boolean(v.reference_source), {
    path: ['reference_source'],
    message: 'Référence OpenStreetMap requise',
  });

export const schemaCreationRangee = z.strictObject({
  nombre: z.number().int().min(1).max(1000),
  pas: z.number().min(0.5).max(100),
  cote: z.enum(['gauche', 'droite', 'deux']),
  decalage: z.number().min(0.5).max(30).default(2),
  prefixe: z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9][A-Za-z0-9_.-]{0,19}$/),
  premier_numero: z.number().int().min(1).max(999999).default(1),
  zone_id: z.string().uuid().optional(),
  surface_m2: z.number().positive().max(100000).multipleOf(0.01),
  rubrique_code: schemaCodeRubrique.default(RUBRIQUE_EMPLACEMENT_DEFAUT),
});
export type CreationRangee = z.infer<typeof schemaCreationRangee>;
export const schemaImportAllees = z.strictObject({
  allees: z.array(schemaCreationAllee).min(1).max(100),
});
export const schemaPositionPlace = z.strictObject({
  position: schemaPosition,
  version_attendue: z.number().int().nonnegative(),
  photo_id: z.string().uuid().optional(),
});

export const schemaChargePositionPlace = schemaPositionPlace
  .omit({ version_attendue: true, photo_id: true })
  .extend({
    photo_id_client: z.string().uuid().optional(),
    attribution_id: z.string().uuid().nullable(),
    commercant_confirme: z.literal(true),
    commercant_nom: z.string().trim().min(2).max(200).optional(),
  });
